import React from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
  title?: string;
  message?: string;
  warning?: string;
}

const ConfirmDeleteModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isDeleting = false,
  title = 'Delete Beat?',
  message = 'Are you sure you want to delete this beat?',
  warning = 'This will also delete all verses recorded on this beat.',
}) => {
  if (!open) return null;

  return (
    <div className="beat-delete-modal" role="dialog" aria-modal="true">
      <div className="beat-delete-modal__panel">
        <h2 className="beat-delete-modal__title">
          <span className="beat-delete-modal__title-accent">{title}</span>
        </h2>
        <p className="beat-delete-modal__message">{message}</p>
        {warning && <p className="beat-delete-modal__warning">{warning}</p>}
        <div className="beat-delete-modal__actions">
          <button type="button" onClick={onClose} className="beat-delete-modal__cancel" disabled={isDeleting}>
            Cancel
          </button>
          <button type="button" onClick={onConfirm} className="beat-delete-modal__confirm" disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
